
import startApp from "../../entry";
import outsourcingPage from "./outsourcing.vue";

startApp(outsourcingPage);
